import React from 'react';

export interface IShipDescParts {
    carrier: 'FedEx' | 'UPS' | '';
    service: string;
    production: string;
}

const sentenceCase = (s: string): string => (s.length ? s[0].toUpperCase() + s.slice(1).toLowerCase() : s);

// Server descriptions look like "FedEx Ground - Standard Production" or "UPS Ground - Shipping Saver".
export function parseShipDesc(desc: string): IShipDescParts {
    const [head, ...rest] = (desc ?? '').split(' - ');
    const match = head.trim().match(/^(FedEx|UPS)\s*(.*)$/i);
    const carrier = match ? (match[1].toLowerCase() === 'ups' ? 'UPS' : 'FedEx') : '';
    return {
        carrier,
        service: match ? match[2].trim() : head.trim(),
        production: sentenceCase(rest.join(' - ').trim()),
    };
}

export function formatShipDates(dates: string): string {
    return (dates ?? '').replace(/^by\s+/i, '').replace(/\s+-\s+/g, ' \u2013 ');
}

export const CarrierLogo = ({carrier}: {carrier: IShipDescParts['carrier']}) => {
    if (carrier === 'FedEx') {
        return (
            <span
                className="ab-fedex"
                role="img"
                aria-label="FedEx"
            >
                <span className="ab-fedex-fed">Fed</span>
                <span className="ab-fedex-ex">Ex</span>
            </span>
        );
    }
    if (carrier === 'UPS') {
        return <span className="ab-ups">UPS</span>;
    }
    return null;
};
